class Invoice {
  constructor(params) {
    this.description = params.description;
    this.invoiceNumber = params.invoiceNumber;
    this.amount = params.amount;
    this.status = params.status.status;
    this.statusId = params.status.id;
    this.invoiceDate = new Date(params.invoiceDate);
    this.remaining = params.remaining;
    this.attachments = params.attachments;
    this.paymentType = params.invoicePaymentType;
    this.expirationDate = new Date(params.expirationDate);
    this.paymentDate = new Date(params.paymentDate);
    this.premiePeriod = params.premiePeriod;
  }
}

export { Invoice as default };
